import { Button } from 'antd'
import { PlusOutlined, EnvironmentOutlined } from '@ant-design/icons'
import PageHeader from '@/components/common/PageHeader'

export const Depots = () => {
  return (
    <div className="p-4 space-y-4">
      <PageHeader
        title="Depot Management"
        subtitle="Manage depot locations, capacity, and operational settings."
        breadcrumbs={[
          { label: 'Home', path: '/' },
          { label: 'Depots' },
        ]}
        actions={
          <>
            <Button icon={<EnvironmentOutlined />}>
              Map View
            </Button>
            <Button
              type="primary"
              icon={<PlusOutlined />}
            >
              Add Depot
            </Button>
          </>
        }
      />

      <div className="mt-6">
        {/* Depot list will go here */}
      </div>
    </div>
  )
}

export default Depots
